<template>
  <div class="app-container">
    <el-form ref="submitDatas" :model="submitDatas" label-width="120px">
      <div class="show-content">
        <el-form-item label="用户ID" style="display:none;">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.uaId" />
          </el-col>
        </el-form-item>
        <p>--------device-------</p>
        <!-- <div v-if="submitDatas.currentTypes=='device'"> -->
        <el-form-item label="正则信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.deviceParser.regex" placeholder="请输入正则信息" />
          </el-col>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.deviceParser.device_replacement" placeholder="请输入设备编号" />
          </el-col>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-col :span="iptWidth">
            <el-select
              v-model="submitDatas.deviceParser.device_type_replacement"
              placeholder="请选择设备类型"
              class="el-col-12"
            >
              <el-option value label="请选择" />
              <el-option
                v-for="(item,idx) in defaultConfig.replacement"
                :key="idx"
                :label="item._key"
                :value="item._val"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="是否是移动端">
          <el-switch v-model="submitDatas.deviceParser.is_mobile_replacement"/>
        </el-form-item>-->
        <el-form-item label="是否是移动端">
          <el-radio-group v-model="submitDatas.deviceParser.is_mobile_replacement">
            <el-radio :label="'1'">是</el-radio>
            <el-radio :label="'0'">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="终端类型">
          <el-col :span="iptWidth">
            <el-select
              v-model="submitDatas.deviceParser.type"
              placeholder="请选择终端类型"
              class="el-col-12"
            >
              <el-option value label="请选择" />
              <el-option
                v-for="(item,idx) in defaultConfig.deviceTypeList"
                :key="idx"
                :label="item._key"
                :value="item._val"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="手机品牌">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.deviceParser.brand_replacement" placeholder="请输入手机品牌" />
          </el-col>
        </el-form-item>
        <p>--------os-------</p>
        <!-- <div v-if="submitDatas.currentTypes=='os'"> -->
        <el-form-item label="正则信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.osParser.regex" placeholder="请输入正则信息" />
          </el-col>
        </el-form-item>
        <el-form-item label="Minor信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.osParser.v2_replacement" placeholder="请输入Minor信息" />
          </el-col>
        </el-form-item>
        <el-form-item label="major信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.osParser.v1_replacement" placeholder="请输入major信息" />
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="是否是移动端">
          <el-switch v-model="submitDatas.osParser.is_mobile_replacement" />
        </el-form-item>-->
        <el-form-item label="是否是移动端">
          <el-radio-group v-model="submitDatas.osParser.is_mobile_replacement">
            <el-radio :label="'1'">是</el-radio>
            <el-radio :label="'0'">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-col :span="iptWidth">
            <el-select v-model="submitDatas.osParser.type" placeholder="请选择设备类型" class="el-col-12">
              <el-option value label="请选择" />
              <el-option
                v-for="(item,idx) in defaultConfig.osTypeList"
                :key="idx"
                :label="item._key"
                :value="item._val"
              />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="手机品牌">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.osParser.brand_replacement" placeholder="请输入手机品牌" />
          </el-col>
        </el-form-item>
        <el-form-item label="系统名称">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.osParser.os_replacement" placeholder="请输入系统名称" />
          </el-col>
        </el-form-item>
        <!-- </div> -->
        <p>--------browser------</p>
        <!-- <div v-if="submitDatas.currentTypes=='browser'"> -->
        <el-form-item label="正则信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.browserParser.regex" placeholder="请输入正则信息" />
          </el-col>
        </el-form-item>
        <el-form-item label="Minor信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.browserParser.v2_replacement" placeholder="请输入Minor信息" />
          </el-col>
        </el-form-item>
        <el-form-item label="major信息">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.browserParser.v1_replacement" placeholder="请输入major信息" />
          </el-col>
        </el-form-item>
        <el-form-item label="来源厂家">
          <!-- <el-radio-group v-model="submitDatas.browserParser.family_replacement">
            <el-radio :label="'1'">是</el-radio>
            <el-radio :label="'0'">否</el-radio>
          </el-radio-group>-->
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.browserParser.family_replacement" placeholder="请输入来源厂家" />
          </el-col>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-col :span="iptWidth">
            <!-- <el-select
              v-model="submitDatas.browserParser.type"
              placeholder="请选择设备类型"
              class="el-col-12"
            >
              <el-option value label="请选择" />
              <el-option
                v-for="(item,idx) in defaultConfig.osTypeList"
                :key="idx"
                :label="item._key"
                :value="item._val"
              />
            </el-select>-->
            <el-input v-model="submitDatas.browserParser.type" placeholder="请输入设备类型" />
          </el-col>
        </el-form-item>
        <el-form-item label="浏览器名称">
          <el-col :span="iptWidth">
            <el-input v-model="submitDatas.browserParser.brand_replacement" placeholder="请输入浏览器名称" />
          </el-col>
        </el-form-item>
        <!-- </div> -->
      </div>
    </el-form>
    <div class="submitBtn">
      <el-button type="primary" @click="onSubmit('submitDatas')">提交</el-button>
      <el-button class="mr8" @click="onCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { setUaParser } from '@/api/uaedit'
import { setLocalStorage } from '@/utils'
export default {
  props: ['tableRowId'],
  data() {
    return {
      iptWidth: 20,
      defaultConfig: {
        currentTypeList: [
          { _key: 'device' },
          { _key: 'os' },
          { _key: 'browser' }
        ],
        replacement: [
          { _key: '手机', _val: 'phone' },
          { _key: 'PC', _val: 'PC' }
        ],
        deviceTypeList: [
          { _key: 'Android', _val: '1' },
          { _key: 'ios', _val: '2' },
          { _key: 'spider', _val: '3' }
        ],
        osTypeList: [
          { _key: 'is_mobile ', _val: '0' },
          { _key: 'mobile', _val: '1' }
        ]
      },

      submitDatas: {
        uaId: '0',
        deviceParser: {
          regex: '',
          device_replacement: '',
          device_type_replacement: '',
          is_mobile_replacement: '',
          type: '',
          brand_replacement: ''
        },
        osParser: {
          regex: '',
          v2_replacement: '',
          v1_replacement: '',
          is_mobile_replacement: '',
          type: '',
          brand_replacement: '',
          os_replacement: ''
        },
        browserParser: {
          regex: '',
          v2_replacement: '',
          v1_replacement: '',
          family_replacement: '',
          type: '',
          brand_replacement: ''
        }
      },
      list: null,
      domainList: null
    }
  },
  created: function() {
    this.submitDatas.uaId = this.tableRowId
  },
  mounted() {
  },
  methods: {
    dataTrans(_datas) {
      const _data = _datas
      const _uaId = _data.uaId
      delete _data.uaId
      for (var item in _data) {
        for (var subItem in _data[item]) {
          if (_data[item][subItem] === '') {
            delete _data[item][subItem]
          }
        }
        if (JSON.stringify(_data[item]) === '{}') {
          delete _data[item]
        }
      }
      _data.uaId = _uaId
      return JSON.stringify(_data)
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          setUaParser(this.submitDatas).then(results => {
            if (results.code === 0) {
              this.$message('提交成功')
              this.$emit('closeModle')
              this.$emit('refresh')
            } else {
              this.$message.error(results.message)
            }
          })
        } else {
          return false
        }
      })
    },
    onCancel() {
      this.setCurrentOperation('cancel')
      this.$emit('closeModle')
      // this.$router.back(-1)
    },
    getL() {
      var _self = this
      _self.$emit('getL', _self.submitData.configId)
    },
    setCurrentOperation(name) {
      setLocalStorage(this.pageName, { type: this.type, name: name })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 0px;
}
.codesql {
  font-size: 11pt;
  font-family: Consolas, Menlo, Monaco, Lucida Console, Liberation Mono,
    DejaVu Sans Mono, Bitstream Vera Sans Mono, Courier New, monospace, serif;
}
.app-container {
  height: calc(100vh - 400px);
  overflow: hidden;
  overflow-y: auto;
}
.el-form {
  height: calc(100vh - 400px - 70px);
  overflow-y: auto;
  /*padding-bottom: 100px;*/
}
.part-title {
  /*display: inline-block;*/
  position: relative;
  padding-left: 20px;
  font-size: 14px;
  margin-left: 10px;
}
.part-title::before {
  position: absolute;
  content: "";
  width: 2px;
  height: 12px;
  background: #108cee;
  left: 11px;
  top: 2px;
}

.show-content {
  margin-bottom: 35px;
  margin-top: 20px;
}
.line {
  text-align: center;
}
.el-form-item {
  margin-bottom: 20px;
}
.param-content {
  /*display: flex;*/
  /*border: 1px solid #DCDFE6;*/
  /*background: #fbfbfb;*/
  /*padding: 8px 10px;*/
  .param-item {
    display: flex;
    label {
      line-height: 25px;
    }
  }
  .operation-btn {
    color: #108cee;
    font-size: 14px;
    line-height: 24px;
    margin-left: 15px;
    i {
      cursor: pointer;
    }
  }
  label {
    color: #606266;
    font-size: 12px;
    font-weight: 500;
  }
}
.app-container {
  position: relative;
}
.submitBtn {
  position: absolute;
  bottom: 0px;
  margin: 0;
  margin-bottom: 0px;
  left: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  text-align: center;
  /*border-top: 1px solid #EBEEF5;*/
  box-shadow: 0px 4px 10px #ccc;
  .el-button {
    padding: 0 16px;
    font-size: 14px;
    height: 30px !important;
  }
}
</style>

